import API from 'src/api'
import utils from 'src/utils'
import { http } from '../boot/axios'
import { Capacitor } from '@capacitor/core'

// Grant `refresh_token` contra cualquiera de los dos emisores (legacy Passport y GraphQL). Los dos
// hablan el mismo protocolo OAuth y solo cambian endpoint y credenciales de cliente, asi que el
// cuerpo vive aqui una sola vez.
function refreshTokenGrant (url, clientId, clientSecret, refreshToken) {
  const payload = {
    grant_type: 'refresh_token',
    client_id: clientId,
    client_secret: clientSecret,
    refresh_token: refreshToken
  }

  return http.post(url, payload)
    .then(response => response.data)
}

export default {
  URL: API.URL + 'users/',
  GRAPHQL_URL: API.GRAPHQL_URL,
  authenticate ({ username, password }) {
    const payload = {
      grant_type: API.OAUTH.GRANT_TYPE,
      client_id: API.OAUTH.CLIENT_ID,
      client_secret: API.OAUTH.CLIENT_SECRET,
      username,
      password
    }

    return new Promise((resolve, reject) => {
      http.post(API.BASE_URL + API.OAUTH.URL, payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  authenticateGQL ({ username, password }) {
    const payload = {
      grant_type: API.OAUTH.GRANT_TYPE,
      client_id: API.OAUTH.GQL_CLIENT_ID,
      client_secret: API.OAUTH.GQL_CLIENT_SECRET,
      username,
      password
    }

    return new Promise((resolve, reject) => {
      http.post(API.GRAPHQL_URL + 'oauth/token', payload)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  authenticateWithRefreshToken (refreshToken) {
    return refreshTokenGrant(
      API.BASE_URL + API.OAUTH.URL, API.OAUTH.CLIENT_ID, API.OAUTH.CLIENT_SECRET, refreshToken
    )
  },
  authenticateGQLWithRefreshToken (refreshToken) {
    return refreshTokenGrant(
      API.GRAPHQL_URL + 'oauth/token', API.OAUTH.GQL_CLIENT_ID, API.OAUTH.GQL_CLIENT_SECRET, refreshToken
    )
  },
  graphqlToken ({ username, password }) {
    const payload = {
      grant_type: API.OAUTH.GRANT_TYPE,
      client_id: API.OAUTH.GQL_CLIENT_ID,
      client_secret: API.OAUTH.GQL_CLIENT_SECRET,
      username,
      password
    }

    return new Promise((resolve, reject) => {
      http.post(API.GRAPHQL_URL + 'oauth/token', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  fetch (id) {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL + `users/${id}`)
        .then(response => { resolve(response.data.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchCurrent () {
    return new Promise((resolve, reject) => {
      http.get(this.GRAPHQL_URL + 'users/user')
        .then(response => { resolve(response.data.data) })
        .catch(error => { reject(error) })
    })
  },
  fetchPaginated (options = {}) {
    const { page, search, limit, franchise_id, organization_id } = {
      ...{
        page: 1,
        search: null,
        limit: 30,
        franchise_id: null,
        organization_id: null
      },
      ...options
    }
    const isOnAdmin = options.isOnAdmin ? options.isOnAdmin : null
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/?limit=${limit}&page=${page}` + (search ? `&search=${search}` : '')
        + (organization_id ? `&organization_id=${organization_id}` : '') + (franchise_id ? `&franchise_id=${franchise_id}` : ''),
        { params: { isOnAdmin } })
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  create (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users`, payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  update (id, payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}users/${id}`, payload)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(error => { reject(error) })
    })
  },
  updateDemo (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}set-demo-until`, payload)
        .then(response => {
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },
  delete (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.GRAPHQL_URL}user-delete/${id}`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  deleteAssignments (userId, assignments) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users/${userId}/assignments`, assignments)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  assignRoles (userId, roleId, data) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users/${userId}/assignments`, {
        assignments: [
          {
            role_id: roleId,
            franchises: data.franchises
          }
        ]
      })
      .then(response => resolve(response))
      .catch(error => reject(error))
    })
  },
  getMails () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/mails`)
        .then(response => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  searchMails (search) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/mails/?search=${search}`)
        .then(response => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  fetchByIds (ids) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/usersByIds`, { params: { ids } })
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  usersByIdsAndRoleId (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/usersByIdsAndRoleId`, { params: payload })
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  fetchByRoles (role_id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/users-by-role?role_id=${role_id}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  fetchByRolesGraph (roleId) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/getUsersByRole`, { params: { roleId } })
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  fetchByOrganization (payload) {
    const params = {
      locations: payload.locations ? payload.locations : null,
      search: payload.search
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/getByOrganization`, { params })
        .then(res => resolve(res.data.data))
        .catch(err => reject(err))
    })
  },
  fetchByValue (payload) {
    const params = {
      locations: payload.locations ? payload.locations : null,
      search: payload.search,
      is_aria_search: payload.isAriaSearch ? payload.isAriaSearch : null
    }
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/getByValue`, { params })
        .then(res => resolve(res.data.data))
        .catch(err => reject(err))
    })
  },
  fetchByRolesAndLocations (payload) {
    payload.locations = payload.locations.join(',')
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL}users/users-by-role?role_id=${payload.role_id}&locations=${payload.locations}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  registerDevice (payload) {
    return http.post(`${API.URL}device-token/`, payload)
  },
  unregisterDevice (token) {
    const payload = { token }
    http.delete(`${API.URL}device-token/`, { data: payload })
      .catch(err => console.error(err))
  },
  reminder (email) {
    return new Promise((resolve, reject) => {
      http.post(`${API.GRAPHQL_URL}reset-password/email`, email)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  reminderConfirm (credentials) {
    return new Promise((resolve, reject) => {
      http.post(`${API.GRAPHQL_URL}reset-password/email/confirm`, credentials)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  reminderExpired (id, code) {
    return new Promise((resolve, reject) => {
      http.get(`${API.GRAPHQL_URL}validate-token/${id}/${code}`)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  downloadReport (emailList) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users-export`, { emailList }, { responseType: 'arraybuffer' })
        .then(async response => {
          if (Capacitor.isNativePlatform()) {
            utils.download('Reporte de Usuarios.xlsx', response.data.file, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          } else {
            const { saveAs } = await import('file-saver')
            saveAs(response.data.file, 'Reporte de Usuarios.xlsx')
          }
          resolve(response.data)
        })
        .catch(error => {
          console.error('Error en la exportación:', error)
          reject(error)
        })
    })
  },
  validate2fa (userId, code2fa) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users/validate2fa/${userId}/code/${code2fa}`, {
        user_id: userId
      })
        .then(data => resolve(data.data))
        .catch(err => reject(err))
    })
  },
  resetPassword (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users/resetPassword/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  revokeBiometric (id) {
    return http.post(`${API.GRAPHQL_URL}users/${id}/revoke-biometric`)
  },
  revokeSessions (id) {
    return http.post(`${API.GRAPHQL_URL}users/${id}/revoke-sessions`)
  },
  fetchSessionSecurity (id) {
    return http.get(`${API.GRAPHQL_URL}users/${id}/session-security`)
  },
  userTemplate () {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users-template`, {
        responseType: 'arraybuffer'
      })
        .then(async response => {
          if (Capacitor.isNativePlatform()) {
            utils.download('Reporte de Usuarios.xlsx', response.data.file, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          } else {
            const { saveAs } = await import('file-saver')
            saveAs(response.data.file, 'Template de Usuarios.xlsx')
          }
          resolve(response.data)
        })
        .catch(error => reject(error))
    })
  },
  uploadTemplateUser (payload) {
    let upload = new FormData()
    upload.append('file', payload.file)
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL}users/import`, upload, {
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
